export function productVariations() {
	// select musi być ukryty w CSSie, a nie usunięty całkowicie, z tego względu, że WooCoomerce potrzebuje selecta do obsługi eventów w JS
	jQuery(document).ready(function ( $ ) {
		$(document).on('change', '.variation-radios input', function() {
		  $('select[name="'+$(this).attr('name')+'"]').val($(this).val()).trigger('change');
		});
	});

	// do przepisania do ES6
	// document.addEventListener('change', () => {
	// 	const variationRadios = document.querySelectorAll('.variation-radios input');
	// 	variationRadios.forEach((radio) => {
	// 		const radioName = radio.name;
	// 		const variationSelect = document.querySelector('.variations select[name="'+radioName+'"]');
	// 		if (radio.checked) {
	// 			const radioColor = radio.value;
	// 			variationSelect.setAttribute('value', radioColor);
	// 			// to nie działa niestety
	// 			const event = document.createEvent('change');
	// 			variationSelect.dispatchEvent(event);
	// 		}
	// 	});
		
	// });
}